import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { AppSettings } from '../shared/AppSettings';

@Injectable()
export class GroupManagementService {
  readonly rootUrl = AppSettings.webApiURL; 

  constructor(public httpClient: HttpClient) { }

  public getGroupList() {
    return this.httpClient.get(`${this.rootUrl}/api/GroupManagement/GetGroupList`);
  }

  public getGroupDetails(GroupId) {
    return this.httpClient.get(`${this.rootUrl}/api/GroupManagement/GetGroupDetails?GroupId=${GroupId}`);
  }

  public SaveGroup(group) {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.httpClient.post(`${this.rootUrl}/api/GroupManagement/SaveGroup`, group, { headers });
  }

  public getGroupDDL() {
    return this.httpClient.get(`${this.rootUrl}/api/GroupManagement/GetGroupDDL`);
  }

  public getRecipientsByGroup(GroupId) {
    return this.httpClient.get(`${this.rootUrl}/api/GroupManagement/GetRecipientsByGroup?GroupId=${GroupId}`);
  }

  public addRecipientsToGroup(GroupId, recipients) {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.httpClient.post(`${this.rootUrl}/api/GroupManagement/AddRecipientsToGroup?GroupId=${GroupId}`, recipients, { headers });
  }

  public deleteRecipientsFromGroup(GroupId, recipients) {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.httpClient.post(`${this.rootUrl}/api/GroupManagement/DeleteRecipientsToGroup?GroupId=${GroupId}`, recipients, { headers });
  }

}



// WEBPACK FOOTER //
// C:/MyProjects_Git/GoDocu/GoDocuMng/Client/src/app/service/group-management.service.ts